var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 114.68,
    viewBox: "0 0 311 114.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(-376.561 -265.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(376.561 265.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M655.475,359.666",
    transform: "translate(-513.942 -311.629)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M647.655,360.9",
    transform: "translate(-510.091 -312.237)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M391.557,285.985l-1.849,5.122H376.562l.006-.317h.4A2.031,2.031,0,0,0,379,288.8V271.221a2.031,2.031,0,0,0-2.03-1.994h-.4l-.006-.317H383.5l0,.317h-.4a2.032,2.032,0,0,0-2.032,1.994v18.915h4.547c3.361,0,4.651-1.738,5.631-4.153Z",
    transform: "translate(-376.561 -266.927)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M421.062,346.467l-.572,7.361c-2.47,4.039-6.665,6.984-13.178,6.984-9.807-.047-16.748-6.753-16.748-17.116,0-10.176,6.707-17.023,17.023-17.023a20.033,20.033,0,0,1,11.092,3.167l.946,6.624h-.389c-1.425-5.475-6.021-8.382-11.657-8.386-8.244,0-13.5,6.236-13.5,15.569,0,9.426,5.346,15.569,13.232,15.76,6.659-.019,12.292-3.335,13.357-12.938Z",
    transform: "translate(-383.458 -295.378)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M535.913,327.965c6,0,9.672,3.442,9.672,9.057,0,7.148-7.761,10.954-13.645,7.853l0-.442s7.716,1.664,9.83-5.053a9.7,9.7,0,0,0,.3-2.829c-.116-4.308-2.332-7.179-6.321-7.179h-5.407v28a3.006,3.006,0,0,0,3,2.95h.594l.007.468H523.677l.008-.468h.594a3.008,3.008,0,0,0,3-2.95V331.133a3,3,0,0,0-2.988-2.7H523.7l-.009-.467Z",
    transform: "translate(-449.024 -296.014)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M595.982,359.962H576.541l.007-.469h.593a3,3,0,0,0,3-2.948V330.287a3,3,0,0,0-2.988-2.686h-.594l-.007-.466h13.7a20.249,20.249,0,0,0,5.59-.853V332.2l-.473-.007v-.835a2.8,2.8,0,0,0-2.626-2.791h-9.56v14.5h7.925a2.31,2.31,0,0,0,2.267-2.31v-.691l.459-.007v7.421l-.459-.005v-.691a2.311,2.311,0,0,0-2.219-2.31h-7.973v14.051h6.726c4.969,0,6.877-2.57,8.325-6.141h.468Z",
    transform: "translate(-475.063 -295.185)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M641.575,327.961c5.683,0,9.165,3.35,9.165,8.814,0,4.541-3.456,8.942-7.965,8.942a11.362,11.362,0,0,1,3.356,3.3s4.042,5.773,5.859,7.756c1.887,2.06,3.622,3.524,6.377,3.546v.47h-2.574a10.09,10.09,0,0,1-8.181-4.111c-.532-.636-5.816-8.325-6.177-8.778-1.225-1.54-2.594-3.165-4.306-3.165V344.3s1.065.023,2.477-.015c2.432-.066,5.99-.646,7.318-4.869a9.728,9.728,0,0,0,.3-2.808c-.116-4.241-2.327-6.958-5.818-7.149-2.392-.131-5.229-.015-5.838-.036v27.95a3,3,0,0,0,3,2.949h.594l.008.469H628.928l.008-.469h.592a3,3,0,0,0,3-2.926V331.377a3,3,0,0,0-3-2.948h-.594l-.007-.467Z",
    transform: "translate(-500.865 -296.013)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M718.069,327.963v.469h-.764a2.393,2.393,0,0,0-2.477,2.214v18.544c0,7.353-5.056,12.256-12.641,12.256-7.8,0-13-4.869-13-12.174V330.754a2.386,2.386,0,0,0-2.48-2.322h-.762v-.469h9.525v.469H694.7a2.382,2.382,0,0,0-2.474,2.251v17.9c0,6.831,3.984,11.386,9.957,11.386,6.266,0,10.442-4.312,10.453-10.782v-18.5a2.388,2.388,0,0,0-2.477-2.258h-.765v-.469Z",
    transform: "translate(-528.948 -296.014)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M786.766,346.467l-.572,7.361c-2.47,4.039-6.666,6.984-13.178,6.984-9.807-.047-16.748-6.753-16.748-17.116,0-10.176,6.706-17.023,17.023-17.023a20.033,20.033,0,0,1,11.092,3.167l.946,6.624h-.389c-1.425-5.475-6.021-8.382-11.658-8.386-8.243,0-13.5,6.236-13.5,15.569,0,9.426,5.346,15.569,13.232,15.76,6.659-.019,12.292-3.335,13.357-12.938Z",
    transform: "translate(-563.589 -295.378)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M834.549,360.786H824.29l.008-.469h.592a3,3,0,0,0,3-2.949V331.354a3,3,0,0,0-3-2.929H824.3l-.007-.469h10.257l-.007.469h-.594a3,3,0,0,0-3,2.919v26.025a3,3,0,0,0,3,2.949h.594Z",
    transform: "translate(-597.094 -296.01)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M873.313,327.044a20.323,20.323,0,0,0,5.649-.854v5.9l-.473-.007v-.836a2.8,2.8,0,0,0-2.673-2.793h-8.889v28.088a3,3,0,0,0,3,2.912h.594l.008.468H860.265l.007-.468h.594a3.006,3.006,0,0,0,3-2.874V328.45h-8.895a2.8,2.8,0,0,0-2.675,2.793v.836l-.472.007v-5.9a20.319,20.319,0,0,0,5.65.854Z",
    transform: "translate(-610.656 -295.14)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M945.961,367.428c-7.391,2.719-14.859-1.783-19.62-15.83l-1.817-5.367H911.661l-3.249,8.362a2,2,0,0,0,1.784,2.945h.412V358H901.17v-.468h.422a4.584,4.584,0,0,0,3.987-2.7l11.612-27.881c-2.035-2.912-5.018-4.645-9.874-2.888l-.132-.474c10.986-4.652,14.277,4.327,16.609,10.927l5.721,16.207c2.647,7.513,7.882,18.064,16.406,16.236Zm-21.912-22.6-3.705-10.939a38.62,38.62,0,0,0-1.961-4.916l-6.174,15.854Z",
    transform: "translate(-634.962 -293.226)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M473.279,338.726c-8.528,1.829-13.767-8.726-16.413-16.243l-5.725-16.214c-2.259-6.4-5.424-15.042-15.636-11.318h0l-.017.007q-.273.1-.552.212a3.677,3.677,0,0,1-.709.171c-.074,0-.147.008-.22.01h-.014v0c-5.088.127-8.275-6.389-9.943-11.123l-3.87-10.964c-1.577-4.465-3.8-10.54-11.236-7.392l.089.321c3.286-1.188,5.3-.016,6.68,1.954l-7.856,18.861a3.1,3.1,0,0,1-2.7,1.827h-.286v.317h6.386v-.314h-.279a1.35,1.35,0,0,1-1.207-1.992l2.2-5.657h8.7l1.23,3.631c3.044,8.982,7.725,12.194,12.451,10.966v-.007a23.9,23.9,0,0,1,3.206-.645v0c3.207-.278,5.386,1.281,6.979,3.564L432.92,326.594a4.586,4.586,0,0,1-3.991,2.7h-.423v.468h9.443V329.3h-.413a1.994,1.994,0,0,1-1.782-2.946l3.25-8.366h12.868l1.818,5.369c4.761,14.054,12.234,18.557,19.627,15.837Zm-60.937-58.489,4.177-10.725a26.06,26.06,0,0,1,1.327,3.325l2.507,7.4Zm27.212,36.344,6.173-15.861a38.063,38.063,0,0,1,1.963,4.918l3.705,10.943Z",
    transform: "translate(-390.507 -265.001)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M680.382,420.96c-.658-3.364,1.376-9.133,9.1-9.133,7.692,0,12.8,5.769,12.8,13.054,0,8.246-6.323,13.867-14.9,13.867-8.506,0-15.015-5.547-15.015-13.83a12.712,12.712,0,0,1,7.134-11.826l.221.333c-3.472,2.284-4.508,7.091-4.508,10.938,0,8.579,5.288,13.276,12.093,13.276,7.1,0,12.129-5.1,12.129-12.833,0-6.213-3.4-11.871-10.242-11.871-6.141,0-8.987,4.586-8.44,7.95Z",
    transform: "translate(-522.261 -337.322)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M749.859,413.258c7.26,0,11.248,3.469,11.267,8.658a7.9,7.9,0,0,1-5.74,7.868c5.514.822,8.88,4.861,8.876,9.991,0,5.849-4.351,9.733-12.066,9.733h-12.62l.009-.517h.656a3.318,3.318,0,0,0,3.316-3.223V416.985a3.283,3.283,0,0,0-3.325-3.215h-.646l-.009-.516Zm2.154,34.361c5.314.025,8.37-2.979,8.364-8.216.006-7.762-6.674-9.056-11.686-9.047l-.013-.487c3.16.012,8.544-.921,8.565-7.58-.02-4.682-2.663-7.374-7.572-7.369h-2.737v32.7Z",
    transform: "translate(-555.367 -338.025)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M810.567,424.616c-.924-4.71,1.925-12.789,12.749-12.789,10.77,0,17.915,8.079,17.915,18.281,0,11.548-8.854,19.419-20.869,19.419-11.91,0-21.024-7.767-21.024-19.368a17.8,17.8,0,0,1,9.989-16.56l.311.466c-4.864,3.2-6.313,9.931-6.313,15.317,0,12.015,7.406,18.591,16.936,18.591,9.943,0,16.985-7.147,16.985-17.97,0-8.7-4.764-16.623-14.344-16.623-8.6,0-12.584,6.422-11.817,11.132Z",
    transform: "translate(-584.803 -337.322)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M673.949,444.452c-5.922,4.219-10.284,5.377-23.614,4.7l.022-.06-.141.057c-2.432-.1-8.12-1.028-11.679-1.131h-2.5V417.083a3.323,3.323,0,0,1,3.323-3.26h.656l.008-.519H628.672l.009.519h.656a3.321,3.321,0,0,1,3.321,3.26v28.74a3.321,3.321,0,0,1-3.319,3.26h-.657l-.009.519h7.3a38.972,38.972,0,0,1,4.02.481c10.819,1.788,23.636,7.039,34.3-5.306Z",
    transform: "translate(-500.74 -338.049)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M505.722,426.5v.318h-.444a4.094,4.094,0,0,0-3.181,1.841l-6.27,10.136v7.592a2.031,2.031,0,0,0,2.031,1.994h.4l.006.317h-6.937l.006-.317h.4a2.033,2.033,0,0,0,2.031-1.975v-7.643l-6.038-10.094a4,4,0,0,0-3.189-1.853h-.432V426.5h7.8v.316h-.4a1.337,1.337,0,0,0-1.11,1.969l4.75,8.875,5.054-8.878.018-.029a1.339,1.339,0,0,0-1.128-1.935h-.4V426.5Z",
    transform: "translate(-429.533 -344.548)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M558.118,448.138H544.971l.006-.317h.4a2.032,2.032,0,0,0,2.032-1.994V428.07a2.031,2.031,0,0,0-2.021-1.816h-.4l-.006-.315h9.266a13.684,13.684,0,0,0,3.78-.577v4l-.319-.005V428.8a1.891,1.891,0,0,0-1.776-1.887H549.47v9.8h5.359a1.561,1.561,0,0,0,1.534-1.561v-.467l.31,0V439.7l-.31,0v-.467a1.563,1.563,0,0,0-1.5-1.562H549.47v9.5h4.547c3.361,0,4.65-1.738,5.629-4.152h.317Z",
    transform: "translate(-459.513 -343.988)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M595.391,443.577l-1.849,5.122H580.4l.006-.317h.4a2.031,2.031,0,0,0,2.03-1.994V428.813a2.031,2.031,0,0,0-2.031-1.994h-.4l-.006-.317h6.938l0,.317h-.4a2.032,2.032,0,0,0-2.032,1.994v18.915h4.548c3.361,0,4.651-1.738,5.63-4.152Z",
    transform: "translate(-476.961 -344.55)",
    fill: "#e5bda0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(504.884 270.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M629.443,286.816V276.762q1.341-.1,2.245-.1a3.689,3.689,0,0,1,2.372.742,2.524,2.524,0,0,1,.932,2.1,2.984,2.984,0,0,1-.536,1.709,4.806,4.806,0,0,1-1.2,1.257q.523.72,1.292,1.716t1,1.25a3.136,3.136,0,0,0,1.949,1.045l-.014.452a3.516,3.516,0,0,1-1.4-.261,3.4,3.4,0,0,1-1.023-.756q-.488-.508-2.422-3.163-1.384,0-2.514-.084v4.151Zm2.782-4.631a1.9,1.9,0,0,0,1.328-.82,2.819,2.819,0,0,0,.706-1.9,1.937,1.937,0,0,0-.727-1.638,3.085,3.085,0,0,0-1.927-.558q-.636,0-1.483.056v4.787Q631.25,282.185,632.225,282.185Z",
    transform: "translate(-629.443 -276.55)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M658.885,286.872v-10.1h4.688v.593h-4.011v3.714h3.63v.579h-3.63v4.618h4.166v.593Z",
    transform: "translate(-643.945 -276.606)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M688.241,277.5a5.211,5.211,0,0,0-2.048-.438q-2.061,0-2.061,1.525a1.917,1.917,0,0,0,.466,1.235,5.1,5.1,0,0,0,1.13,1.017q.664.444,1.328.911a4.725,4.725,0,0,1,1.13,1.115,2.376,2.376,0,0,1,.466,1.413,2.289,2.289,0,0,1-.862,1.941,3.842,3.842,0,0,1-2.379.657,4.3,4.3,0,0,1-2.591-.777l.339-.508a4,4,0,0,0,2.231.664,3.068,3.068,0,0,0,1.864-.487,1.65,1.65,0,0,0,.649-1.406,1.88,1.88,0,0,0-.466-1.207,5.424,5.424,0,0,0-1.13-1.031q-.664-.459-1.327-.939a4.815,4.815,0,0,1-1.13-1.144,2.433,2.433,0,0,1-.466-1.426,1.917,1.917,0,0,1,.742-1.588,3.146,3.146,0,0,1,2.005-.586,5.492,5.492,0,0,1,2.351.508Z",
    transform: "translate(-655.733 -276.441)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M711.615,277.368H708.2v-.593h7.513v.593h-3.418v9.5h-.677Z",
    transform: "translate(-668.234 -276.606)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M735.25,283.3l-1.454,3.5h-.721l4.251-10.168h.4l4.265,10.168h-.762l-1.455-3.5Zm2.231-5.536a.735.735,0,0,0-.056.169q-.2.607-.381,1.031l-1.554,3.756h4.039l-1.553-3.742A6.828,6.828,0,0,1,737.481,277.765Z",
    transform: "translate(-680.488 -276.537)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M771.859,285.89a4.4,4.4,0,0,1-5.938-.007,4.737,4.737,0,0,1-.981-3.163v-5.945h.678v5.945q0,3.727,3.269,3.728t3.269-3.728v-5.945h.678v5.945A4.754,4.754,0,0,1,771.859,285.89Z",
    transform: "translate(-696.183 -276.606)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M798.751,286.816V276.762q1.341-.1,2.245-.1a3.691,3.691,0,0,1,2.373.742,2.523,2.523,0,0,1,.932,2.1,2.98,2.98,0,0,1-.537,1.709,4.8,4.8,0,0,1-1.2,1.257q.522.72,1.292,1.716t1,1.25a3.139,3.139,0,0,0,1.949,1.045l-.014.452a3.516,3.516,0,0,1-1.4-.261,3.406,3.406,0,0,1-1.024-.756q-.487-.508-2.422-3.163-1.384,0-2.514-.084v4.151Zm2.782-4.631a1.9,1.9,0,0,0,1.327-.82,2.821,2.821,0,0,0,.706-1.9,1.938,1.938,0,0,0-.727-1.638,3.085,3.085,0,0,0-1.927-.558q-.636,0-1.483.056v4.787Q800.558,282.185,801.533,282.185Z",
    transform: "translate(-712.837 -276.55)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M827.14,283.3l-1.455,3.5h-.72l4.251-10.168h.4l4.265,10.168h-.763l-1.454-3.5Zm2.231-5.536a.814.814,0,0,0-.056.169q-.2.607-.382,1.031l-1.553,3.756h4.039l-1.553-3.742A6.8,6.8,0,0,1,829.371,277.765Z",
    transform: "translate(-725.749 -276.537)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M858.424,278.3l.028,1.2v7.287h-.678V276.607h.311l6.651,7.668q.677.805,1.045,1.285-.056-.678-.056-1.553v-7.315h.678v10.181h-.31l-6.778-7.809q-.707-.805-.9-1.073Z",
    transform: "translate(-741.909 -276.523)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M893.612,277.368h-3.418v-.593h7.513v.593H894.29v9.5h-.678Z",
    transform: "translate(-757.878 -276.606)",
    fill: "#e5bda0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.132f413326ee47251bce231baaaeb9e6.svg";
export { ForwardRef as ReactComponent };